import {Trans} from '@common/i18n/trans';
import React, {Fragment, ReactNode, useCallback, useEffect, useState} from 'react';
import { Tabs } from '@common/ui/tabs/tabs';
import { TabList } from '@common/ui/tabs/tab-list';
import { Tab } from '@common/ui/tabs/tab';
import { TabPanel, TabPanels } from '@common/ui/tabs/tab-panels';
import { apiClient } from '@common/http/query-client';
import { CreateRateSheetPage } from './create-rate-sheet-page';
// import { AnalysisRateSheetPage } from './analysis-rate-sheet-page';
import { useAuth } from '@common/auth/use-auth';
import { getCookie, setCookie } from '@common/utils/hooks/use-cookie';
import { AnalysisRateSheetPage } from './analysis/analysis-rate-sheet-page';

interface DetailPanelProps {
  marketRateDate: string;
  timeChange: any,
  selectDefaultTab: boolean
}
export function MarketRateDateDetail({marketRateDate, timeChange, selectDefaultTab}: DetailPanelProps) {

  const fetchMarketRate =  useCallback(async (marketRateDate: string) => {
    return await apiClient.get(`market-rates/${marketRateDate}`);
  }, []);

  return (
    <GetRateSheetPage selectDefaultTab={selectDefaultTab} fetchMarketRate={fetchMarketRate} marketRateDate={marketRateDate} timeChange={timeChange}/>
  );
}

export function GetRateSheetPage({fetchMarketRate, marketRateDate, timeChange, selectDefaultTab}: any) {
  const [id, setId] = useState<any>();
  const [items, setItems] = useState<any>([]);
  const [dataCriterias, setDataCriterias] = useState([]);
  const [loanProgramTypes, setLoanProgramTypes] = useState([]);

  const [status, setStatus] = useState('');
  const [investorCode, setInvestorCode] = useState('');
  const [loanProgramType, setLoanProgramType] = useState('');
  const [sheetName, setSheetName] = useState('');
  
  
  window.Echo.channel('rate-sheet').listen('.process', (e: any) => {
    if (id && e.data[id] != undefined) {
      const item = e.data[id];
      if (item.status) {
        setStatus(item.status);
      }

      if (item.investorCode) {
        setInvestorCode(item.investorCode);
      }

      if (item.loanProgramType) {
        setLoanProgramType(item.loanProgramType);
      }

      if (item.sheetName) {
        setSheetName(item.sheetName);
      }

      if (item.dataCriterias) {
        setDataCriterias(item.dataCriterias);
      }
      
    }
  });

  useEffect(() => {
    if (marketRateDate || timeChange || investorCode || loanProgramType || status || selectDefaultTab) {
      fetchMarketRate(marketRateDate).then(async (response: any) => {
        const data_items = await response.data.market_rate;
        setItems(data_items.items);
        // check this one
        setId(data_items.id);
        if (data_items.data_criterias) {
          setDataCriterias(data_items.data_criterias);
        }
        if (data_items.loan_program_types) {
          setLoanProgramTypes(data_items.loan_program_types);
        }
      })
    }
  }, [marketRateDate, timeChange, investorCode, loanProgramType, status, sheetName, selectDefaultTab]);

  return (
    <>
     <MarketRateDateView selectDefaultTab={selectDefaultTab} id={id} items={items} dataCriterias={dataCriterias} loan_program_types={loanProgramTypes} marketRateDate={marketRateDate} timeChange={timeChange}/>
     </>
  );
}



export function MarketRateDateView({id, marketRateDate, selectDefaultTab, timeChange, items, dataCriterias, loan_program_types}: any) {
  const {user} = useAuth();
  const user_id = user?.id;

  const default_tab = user_id && getCookie('rate-sheet-tab-'+user_id) ? parseInt(getCookie('rate-sheet-tab-'+user_id)) : 0;
  const [selectedTab, setSelectedTab] = useState(default_tab!);

  const onChangeTab = (tabIndex: number) => {
    setSelectedTab(tabIndex);
    if (user_id) {
      setCookie('rate-sheet-tab-'+user_id, tabIndex.toString());
    }
  }

  useEffect(() => {
    if (selectDefaultTab && timeChange) {
      setSelectedTab(0);
    }
  }, [selectDefaultTab, timeChange]);

  return (
    <Fragment>
      <Tabs isLazy defaultSelectedTab={0}
        selectedTab={selectedTab}
        onTabChange={onChangeTab}
        >
          <TabList>
            <Tab>
              <Trans message="Upload Rate Sheet" />
            </Tab>
            <Tab>
              <Trans message="Analysis" />
            </Tab>
            
          </TabList>
          <TabPanels className="pt-20">
            <TabPanel>
              <>
              <CreateRateSheetPage id={id} items={items} marketRateDate={marketRateDate} timeChange={timeChange}/>
              </>
            </TabPanel>
            <TabPanel>
             <>
              {/* <AnalysisRateSheetPage id={id} items={items} data_criterias={dataCriterias} marketRateDate={marketRateDate} timeChange={timeChange}/> */}
              <AnalysisRateSheetPage id={id} items={dataCriterias} marketRateDate={marketRateDate} timeChange={timeChange} loan_program_types={loan_program_types}/>
             </>
            </TabPanel>
          </TabPanels>
        </Tabs>

    </Fragment>
  );
}

